import { FirebaseOptions, getApp, getApps, initializeApp } from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const config: FirebaseOptions = {
  apiKey: import.meta.env.VITE_FIREBASE_APIKEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTHDOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECTID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGEBUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGESENDERID,
  appId: import.meta.env.VITE_FIREBASE_APPID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENTID,
};

const paymentsFirestoreConfig: FirebaseOptions = {
  apiKey: import.meta.env.VITE_FIREBASE_PAYMENTS_APIKEY,
  authDomain: import.meta.env.VITE_FIREBASE_PAYMENTS_AUTHDOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PAYMENTS_PROJECTID,
  storageBucket: import.meta.env.VITE_FIREBASE_PAYMENTS_STORAGEBUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_PAYMENTS_MESSAGINGSENDERID,
  appId: import.meta.env.VITE_FIREBASE_PAYMENTS_APPID,
  measurementId: import.meta.env.VITE_FIREBASE_PAYMENTS_MEASUREMENTID,
};

const app = getApps().length ? getApp() : initializeApp(config);
const analytics = getAnalytics(app);
const firestore = getFirestore(app);

const hasPaymentsFirestoreConfig = [
  paymentsFirestoreConfig.apiKey,
  paymentsFirestoreConfig.authDomain,
  paymentsFirestoreConfig.projectId,
  paymentsFirestoreConfig.appId,
].every(Boolean);

const paymentsFirestoreApp = hasPaymentsFirestoreConfig
  ? getApps().some((item) => item.name === "payments-firestore")
    ? getApp("payments-firestore")
    : initializeApp(paymentsFirestoreConfig, "payments-firestore")
  : null;

const paymentsFirestore = paymentsFirestoreApp
  ? getFirestore(paymentsFirestoreApp)
  : null;

export { analytics as firebaseAnalytics };
export { firestore as firebaseFirestore, paymentsFirestore };
